import type { MaxwellBlock } from "@/types/blocks";

import { CalloutBlockView } from "./CalloutBlock";
import { ChartBlockView } from "./ChartBlock";
import { DownloadBlockView } from "./DownloadBlock";
import { EntityListBlockView } from "./EntityListBlock";
import { KpiRowBlockView } from "./KpiRowBlock";
import { TableBlockView } from "./TableBlock";
import { TimelineBlockView } from "./TimelineBlock";

/** Render a run of Maxwell content blocks. One vertical stack; each block owns
 *  its own card/spacing. Unknown block types are skipped (forward-compatible). */
export function MaxwellBlocks({ blocks }: { blocks: MaxwellBlock[] }) {
  if (blocks.length === 0) return null;
  return (
    <div className="flex flex-col gap-3">
      {blocks.map((block, i) => (
        <BlockView key={i} block={block} />
      ))}
    </div>
  );
}

function BlockView({ block }: { block: MaxwellBlock }) {
  switch (block.type) {
    case "table":
      return <TableBlockView block={block} />;
    case "chart":
      return <ChartBlockView block={block} />;
    case "kpi_row":
      return <KpiRowBlockView block={block} />;
    case "timeline":
      return <TimelineBlockView block={block} />;
    case "entity_list":
      return <EntityListBlockView block={block} />;
    case "callout":
      return <CalloutBlockView block={block} />;
    case "download":
      return <DownloadBlockView block={block} />;
    default:
      return null;
  }
}
